import { render, staticRenderFns } from "./OtherForm.vue?vue&type=template&id=1c3628dd&scoped=true"
import script from "./OtherForm.vue?vue&type=script&lang=js"
export * from "./OtherForm.vue?vue&type=script&lang=js"
import style0 from "./OtherForm.vue?vue&type=style&index=0&id=1c3628dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3628dd",
  null
  
)

export default component.exports